import type { MilkdownPlugin } from '@milkdown/kit/ctx';
import { $nodeSchema } from '@milkdown/kit/utils';

const PLATFORM_CELL_ATTRS = {
  colspan: { default: 1 },
  rowspan: { default: 1 },
  alignment: { default: 'left' },
};

const noopMarkdown = {
  match: () => false,
  runner: () => {},
};

/** Platform `tr`; Milkdown GFM uses `table_header_row` / `table_row`.
 * Do NOT set `tableRole` — that overwrites Milkdown's entry in prosemirror-tables'
 * `tableNodeTypes` (last role wins) and breaks tableEditing/fixTables after we
 * widen `table` content to accept Platform rows for hydration.
 */
export const trCompatNode = $nodeSchema('tr', () => ({
  content: '(th | td)*',
  isolating: true,
  parseDOM: [{ tag: 'tr' }],
  toDOM: () => ['tr', 0],
  parseMarkdown: noopMarkdown,
  toMarkdown: noopMarkdown,
}));

/** Platform `th`; Milkdown GFM uses `table_header`. */
export const thCompatNode = $nodeSchema('th', () => ({
  content: 'paragraph+',
  isolating: true,
  attrs: PLATFORM_CELL_ATTRS,
  parseDOM: [{ tag: 'th' }],
  toDOM: (node) => ['th', node.attrs.alignment ? { style: `text-align: ${node.attrs.alignment}` } : {}, 0],
  parseMarkdown: noopMarkdown,
  toMarkdown: noopMarkdown,
}));

/** Platform `td`; Milkdown GFM uses `table_cell`. */
export const tdCompatNode = $nodeSchema('td', () => ({
  content: 'paragraph+',
  isolating: true,
  attrs: PLATFORM_CELL_ATTRS,
  parseDOM: [{ tag: 'td' }],
  toDOM: (node) => ['td', node.attrs.alignment ? { style: `text-align: ${node.attrs.alignment}` } : {}, 0],
  parseMarkdown: noopMarkdown,
  toMarkdown: noopMarkdown,
}));

export const platformTableCompatNodes = [trCompatNode, thCompatNode, tdCompatNode] as unknown as MilkdownPlugin[];
